var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social__followers"},_vm._l((_vm.users),function(user){return _c('UserEntry',{key:user.id,attrs:{"item":user}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }